<template>
  <div class="wrap">
    <div class="headers">
      <div class="logo">
        <a href="https://bluexad.ai/" target="_blank">
          <img src="../../assets/img/logo_col.png">
          <span class="logo-text">| {{$t("login.logoDevPlatform")}}</span>
        </a>
      </div>
    </div>
    <div class="left_bottom_text_plain">
      <p>{{$t("login.abroadCooperation")}}</p>
    </div>

    <div class="header-right">
      <div class="header-user-con">
        <el-dropdown trigger="click" @command="langChange">
          <span class="el-dropdown-link">
            {{language}} <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item divided  command="zh">中文</el-dropdown-item>
            <el-dropdown-item divided  command="en">English</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="ms-login">
      <el-form size="large">
        <el-row class="ms-title">
          <el-col :span="24">
            <p class="user-behavior">{{$t("login.welcomeLogin")}}</p>
            <p class="devPlatform">{{$t("login.devPlatform")}}</p>
          </el-col>
        </el-row>
        <el-tabs v-model="type" @tab-click="handleClick" stretch>
          <el-tab-pane :label="$t('login.emailLogin')" name="1">
            <el-form :model="loginEmailData" :rules="emailRules" ref="emailRef" class="ms-content" size="large">
              <el-form-item label prop="email">
                <el-input
                  v-model.trim="loginEmailData.email"
                  :placeholder="$t('forget.Email')"
                  prefix-icon="el-icon-message"
                ></el-input>
              </el-form-item>
              <el-form-item label prop="password">
                <el-input
                  type="password"
                  show-password
                  v-model="loginEmailData.password"
                  prefix-icon="el-icon-lock"
                  :placeholder="$t('login.password') +','+ $t('login.min')"
                ></el-input>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane :label="$t('login.mobileLogin')" name="2">
            <el-form :model="loginMobileData" :rules="mobileRules" ref="mobileRef" class="ms-content" size="large">
              <el-form-item label prop="mobile">
                <el-input
                  :placeholder="$t('forget.tel')"
                  v-model.trim="loginMobileData.mobile"
                  prefix-icon="el-icon-mobile">
                  <template slot="prepend">
                    <el-select 
                      v-model="loginMobileData.itu_code" 
                      style="width: 100px"
                    >
                      <el-option
                        v-for="item in ituList"
                        :key="item.value"
                        :label="`${item.value}`"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item class="captcha" label prop="captcha">
                <el-input v-model="loginMobileData.captcha" prefix-icon="el-icon-check" :placeholder="$t('login.imgCode')"></el-input>
                <div class="captcha-img">
                  <img :src="captchaUrl" />
                  <div @click="handleCaptcha" class="cover"></div>
                </div>
              </el-form-item>
              <el-form-item class="send-code-info" label prop="sms_code">
                <el-input
                  v-model.trim="loginMobileData.sms_code"
                  prefix-icon="el-icon-chat-line-square"
                  :placeholder="$t('forget.msgCode')"
                ></el-input>
                <el-button
                  class="send-code-btn"
                  @click="handleSendCode"
                  :disabled="showSendCodeBtn"
                  type="primary"
                >{{ sendCodeBtnName }}</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
  
        <el-form-item label prop="rememberMe">
          <el-col class="tip-msg" :span="12">
            <el-checkbox text-color="#9b9b9c" v-model="rememberMe">{{$t("login.autoLogin")}}</el-checkbox>
          </el-col>
          <el-col :span="12" v-if="showForgetEntry">
            <p class="tip-reg" @click="goForget">{{$t("forget.entry")}}</p>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button class="submit-button" type="primary" @click="submitForm('ruleForm')">{{$t("login.login")}}</el-button>
        </el-form-item>
        <el-form-item>
          <p class="toSignUp" @click="handleSignup">{{$t("login.register")}}</p>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import util from '@/utils/util'
import perm from '@/utils/permission'
const DOMAIN_CONFIG = require('@/utils/domainConfig')
export default {
  data() {
    return {
      captchaUrl: "",
      // showSendCodeBtn: true,
      sendCodeBtnName: "获取验证码",
      type: "1", //类型:1邮箱登录,2手机号登录
      timer: null,
      loginEmailData: {
        email: "", //邮箱
        password: "", //密码
        type: 1 //类型:1邮箱登录,2手机号登录
      },
      loginMobileData: {
        mobile: "", //手机号
        captcha: "", //图形验证码
        sms_code: "", //短信验证码
        itu_code: "+86", //国际区号
        type: 2 //类型:1邮箱登录,2手机号登录
      },
      ituList: [
        { value: "+86",label: "CHN"},
        { value: "+852",label: "HKG"},
        { value: "+853",label: "MAC"},
        { value: "+886",label: "TWN"},
        { value: "+1",label: "USA/CAN"},
        { value: "+7",label: "RUS"},
        { value: "+60",label: "MYS"},
        { value: "+62",label: "IDN"},
        { value: "+65",label: "SGP"},
        { value: "+84",label: "VNM"}
      ],
      rememberMe: true,
      language: '中文',
    };
  },
  computed: {
    // 忘记密码入口只在国内域名下隐藏，本地和预发布环境也能用
    showForgetEntry() {
      return window.location.hostname !== DOMAIN_CONFIG.DOMESTIC_DOMAIN
    },
    showSendCodeBtn() {
      const isValidCaptcha = this.loginMobileData.captcha.length === 4;
      const isValidPhone = this.loginMobileData.itu_code == '+86'
        ? this.loginMobileData.mobile.length == 11 
        : this.loginMobileData.mobile.length >= 5 && this.loginMobileData.mobile.length <= 16;
      
      return !isValidCaptcha && !isValidPhone;
    }, 
    emailRules() {
      return {
        email: [
          { type: 'email', message: this.$t('login.emailError'), trigger: ['blur', 'change'] },
          { required: true, message: this.$t('login.emailCheck'), trigger: "blur" }
        ],
        password: [
          { required: true, message:  this.$t('login.pwdCheck'), trigger: "blur" },
          { min: 6, message: this.$t('login.min'), trigger: "blur" }
        ],
      }
    },
    mobileRules() {
      return {
        mobile: [{ validator: this.validatePhone, trigger: "blur" }],
        captcha: [{ required: true, message: this.$t('login.codeCheck'), trigger: "blur" }],
        sms_code: [
          { required: true, message: this.$t('forget.smsCheck'), trigger: "blur" }
        ]
      }
    }
  },
  created() {
    this.sendCodeBtnName = this.$t('forget.getCode')
    var lang = localStorage.getItem("lang")
    if(lang == 'en') {
      this.language = 'English'
    } else if (lang == 'zh') {
      this.language = '中文'
    }
  },
  methods: {
    // 中英文切换
    langChange(command) {
        this.$i18n.locale = command
        localStorage.setItem("lang", command)
        if(command == 'en') {
            this.language = 'English'
        } else if (command == 'zh') {
            this.language = '中文'
        }
    },
    // 手机号验证
    validatePhone(rule, value, callback) {
      if (value == "") {
        callback(new Error(this.$t('forget.phoneCheck')));
      } else {
        let reg = /^1[3-9]\d{9}$/
        if(this.loginMobileData.itu_code != '+86') {
          reg = /^[0-9]{5,16}$/
        }
        if (!reg.test(value)) {
          callback(new Error(this.$t('login.phoneError')));
        } else {
          callback();
        }
      }
    },
    // 切换登录方式
    handleClick(val) {
      if(this.type == "2") {
        this.handleCaptcha()
      }
    },
    submitForm() {
      if(this.type == "1") { //邮箱登录
        this.$refs.emailRef.validate((valid, data) => {
          if (valid) {
            this.handleLogin(this.loginEmailData);
          } else {
            this.$message.error(this.$t('message.errorComplete'));
          }
        })
      } else { //手机号登录
        this.$refs.mobileRef.validate((valid, data) => {
          if (valid) {
            let params = {
              mobile: this.loginMobileData.mobile,
              sms_code: this.loginMobileData.sms_code,
              itu_code: this.loginMobileData.itu_code,
              type: 2
            }
            this.handleLogin(params);
          } else {
            this.$message.error(this.$t('message.errorComplete'));
          }
        })
      }
    },
    // 登录接口
    handleLogin(params) {
      this.__postData("login", params, res => {
        if(res.code == 1) {
          this.$message.error(res.msg)
        } else {
          // user cookie 只存页面会读的几个字段，导航树由下面的 saveFromLogin 存进 localStorage
          const userStr = util.userCookieValue(res)
          if(this.rememberMe) {
            // 判断是否勾选了下次自动登录，将token存在cookie中，存放七天
            util.setCookie("token", res.token, 7)
            util.setCookie("user", userStr, 7)
            // 将user信息也存到cookie中
          } else {
            util.setCookie("token", res.token)
            util.setCookie("user", userStr)
          }
          // 导航树跟着登录响应一起回来（没有单独的接口），存一份给后台的
          // 顶部导航和路由守卫用；响应里没带就按主账号兜底渲染
          perm.saveFromLogin(res)
          // 判断登录成功是海外用户还是国内用户，如果是海外用户，跳转到海外应用列表页，国内用户跳转到国内应用列表页
          if(res.area == 2) { //海外
            if(res.verify_code == 0 && !res.old_user) {
              this.$router.push("/abroad/account/companyInfo")
            }else {
              // 落到这个账号能进的第一个页面。主账号算出来就是应用列表，和原来一样；
              // 子账号不一定有应用列表的权限，写死的话会被路由守卫再弹一次
              this.$router.push(perm.firstAccessiblePath() || "/abroad/app/list");
            }
          } else {
            this.$router.push("/app/list");
          }
        }
      },
      errmsg => {
        this.$message.error(errmsg);
      });
    },
    handleSignup() {
      this.$router.push("/signup")
    },
    // 跳找回密码页，把当前 tab 和已经填了的账号一起带过去
    goForget() {
      let query = this.type == "1"
        ? { type: 2, account: this.loginEmailData.email }
        : { type: 1, account: this.loginMobileData.mobile, itu: this.loginMobileData.itu_code }
      this.$router.push({ path: "/forget", query: query })
    },
    handleCaptcha() {
      this.__postData("getCaptcha", {}, res => {
          if(res.code == 1) {
            this.$message.error(res.msg);
          } else {
            this.captchaUrl = res.image_data;
          }
        },
        errmsg => {
          this.$message.error(errmsg);
        }
      );
    },
    // 点击发送短信验证码
    handleSendCode() {
      if (this.timer) {
        return;
      }
      let params = {
        mobile: this.loginMobileData.mobile,
        captcha: this.loginMobileData.captcha,
        itu_code: this.loginMobileData.itu_code,
        type: 2, //1注册,2登录,3找回密码
      };
      this.__postData("getSms", params, res => {
          if(res.code == 1) {
            this.$message.error(res.msg);
            return
          }
          this.$message.success(this.$t('login.msg1'));
          let count = 60;
          this.sendCodeBtnName = count + "s";
          this.showSendCodeBtn = true;
          this.timer = setInterval(() => {
            if (count > 0 && count <= 60) {
              count--;
              this.sendCodeBtnName = count + "s";
            } else {
              this.showSendCodeBtn = false;
              clearInterval(this.timer);
              this.timer = null;
              this.sendCodeBtnName = this.$t('forget.getCode');
            }
          }, 1000);
        },
        errmsg => {
          this.$message.error(errmsg);
        }
      );
    },
  }
};
</script>

<style scoped>
.wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background-image: url(../../assets/img/bg.png);
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 600px;
}
.headers {
  position: relative;
  height: 100%;
  width: 65%;
  min-width: 800px;
  box-sizing: border-box;
  padding-left: 2%;
  padding-top: 2%;
}
.headers .logo {
  margin: 26px;
}
.headers .logo img {
  height: 45px;
}
.headers .logo a {
  color: #fff;
  float: left;
  display: flex;
  align-items: flex-end;
}
.logo-text {
  font-size: 20px;
  font-weight: 600;
  color: #0B1D40;
  margin-left: 10px;
  white-space: nowrap;
}
.header-right{
  position: absolute;
  top: 12px;
  right: 60px;
  z-index: 10;
}
.header-right .el-dropdown{
  color: rgba(0, 0, 0, 0.85);
}
.header-right .doc-download{
  color:#000;
  font-size: 14px;
  padding: 0 20px;
  cursor: pointer;
}
.headers .txt-login {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 519px;
  height: 100px;
  text-align: center;
}
.headers .txt-login img:first-child {
  width: 519px;
  height: 57.5px;
}
.headers .txt-login img:last-child {
  width: 288px;
  height: 36px;
  margin-top: 20px;
}
.left_bottom_text_plain {
  position: absolute;
  bottom: 50px;
  left: 54px;
}
.left_bottom_text_plain p {
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
}
.ms-title {
  width: 100%;
  line-height: 50px;
  text-align: left;
  font-size: 20px;
  margin-bottom: 20px;
}
.ms-login {
  position: absolute;
  right: 138px;
  top: 50%;
  transform: translateY(-50%);
  width: 494px;
  padding: 30px 47px;
  background-color: #fff;
  box-sizing: border-box;
  border-radius: 6px;
}
.login-tips {
  font-size: 14px;
  line-height: 30px;
  color: #fff;
}
.submit-button {
  width: 100%;
  font-size: 14px;
  border-radius: 6px;
}
.toSignUp {
  width: 100%;
  font-size: 14px;
  color: #3361FF;
  cursor: pointer;
  text-align: center;
}
.tip-msg {
  font-size: 14px;
  line-height: 20px;
  color: #9b9b9c;
  font-weight: 500;
}
.tip-reg {
  text-align: right;
  cursor: pointer;
  color: #3361FF;
}
.tip-reg:hover {
  color: #3361FF;
}

.is-active {
  border-bottom: 2px solid #409eff;
}
.user-behavior {
  cursor: pointer;
  font-size: 24px;
  color: rgba(0, 0, 0, 0.85);
}
.devPlatform {
  font-size: 33px;
  font-weight: 700;
}

.ms-content .el-input__inner {
  background: rgba(246, 248, 250, 1);
  line-height: normal;
  font-size: 14px;
  color: rgba(98, 109, 116, 1);
}
.captcha .el-input {
  width: 73%;
  display: inline-block;
}
.captcha-img {
  height: 40px;
  width: 25%;
  float: right;
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
}
.captcha-img img {
  width: 100%;
  height: 40px;
}
.captcha-img:hover .cover {
  z-index: 1;
}
.cover {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: -1;
  background-color: rgba(123, 139, 137, 0.6);
  background-image: url(../../assets/img/captcha-refresh.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 16px 16px;
}
.el-checkbox {
  color: #9b9b9c;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #9b9b9c;
}
::-webkit-input-placeholder {
  color: rgba(98, 109, 116, 1);
}
::-moz-placeholder {
  color: rgba(98, 109, 116, 1);
} /* firefox 19+ */
:-ms-input-placeholder {
  color: rgba(98, 109, 116, 1);
} /* Internet Explorer 10+ */
:-moz-placeholder {
  color: rgba(98, 109, 116, 1);
} /* firefox 14-18 */
.el-icon-user-solid:before {
  display: inline-block;
  content: "";
  width: 14px;
  height: 15px;
  background: url("../../assets/img/user.png");
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center center;
}
.el-icon-s-check:before {
  display: inline-block;
  content: "";
  width: 13px;
  height: 16px;
  background: url("../../assets/img/password.png");
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center center;
}
.el-icon-check:before {
  display: inline-block;
  content: "";
  width: 14px;
  height: 15px;
  background: url("../../assets/img/pic.png");
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center center;
}
.el-input__icon {
  margin-top: 3px;
}
.send-code-info .el-input {
  width: 68%;
  display: inline-block;
}
.send-code-btn {
  float: right;
  width: 30%;
  height: 40px;
  padding: 0;
}
</style>
